import { useTranslation } from 'react-i18next';

export default function AboutSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-20 md:py-28 px-6 md:px-10 bg-background-50">
      <div className="max-w-4xl mx-auto text-center">
        {/* Tag */}
        <div className="inline-flex items-center px-5 py-2 rounded-full border border-foreground-200 mb-8">
          <span className="text-sm font-label font-medium text-foreground-700 whitespace-nowrap">{t('about.tag')}</span>
        </div>

        {/* Title with inline product icons */}
        <h2 className="font-heading text-3xl md:text-5xl font-semibold text-foreground-950 leading-snug mb-16">
          {t('about.title_line1')}
          <span className="inline-flex items-center mx-2 align-middle">
            <img
              src="https://readdy.ai/api/search-image?query=Single%20espadrille%20wedge%20sandal%20in%20natural%20raffia%20with%20ankle%20ribbon%20ties%20on%20warm%20sand%20surface%2C%20minimalist%20product%20detail%20photography%2C%20soft%20golden%20hour%20lighting%2C%20Mediterranean%20summer%20aesthetic&width=80&height=80&seq=icon-shoe-itaobuy-2026&orientation=squarish"
              alt="scarpe"
              className="w-10 h-10 md:w-14 md:h-14 rounded-xl object-cover inline-block"
            />
          </span>
          <br />
          {t('about.title_line2')}
          <span className="inline-flex items-center mx-2 align-middle">
            <img
              src="https://readdy.ai/api/search-image?query=Cashmere%20blend%20knit%20sweater%20in%20soft%20camel%20color%20folded%20on%20rustic%20wooden%20surface%2C%20warm%20candlelight%20ambiance%2C%20cozy%20minimalist%20product%20photography%2C%20autumn%20hygge%20aesthetic%20with%20gentle%20shadows&width=80&height=80&seq=icon-hoodie-itaobuy-2026&orientation=squarish"
              alt="felpe"
              className="w-10 h-10 md:w-14 md:h-14 rounded-xl object-cover inline-block"
            />
          </span>
          <br />
          {t('about.title_line3')}
          <span className="inline-flex items-center mx-2 align-middle">
            <img
              src="https://readdy.ai/api/search-image?query=Woven%20leather%20bucket%20bag%20with%20wooden%20bead%20handle%20on%20sunlit%20terracotta%20floor%2C%20Mediterranean%20courtyard%20setting%2C%20soft%20afternoon%20light%2C%20artisan%20craft%20aesthetic%2C%20warm%20earthy%20tones%20with%20gentle%20shadows&width=80&height=80&seq=icon-bag-itaobuy-2026&orientation=squarish"
              alt="accessori"
              className="w-10 h-10 md:w-14 md:h-14 rounded-xl object-cover inline-block"
            />
          </span>
        </h2>

        {/* Problem / Solution */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 text-left">
          <div className="bg-background-100 rounded-2xl p-8 md:p-10">
            <div className="flex items-center gap-3 mb-4">
              <span className="w-10 h-10 rounded-full bg-primary-50 flex items-center justify-center">
                <i className="ri-error-warning-line text-primary-500 text-lg w-5 h-5 flex items-center justify-center"></i>
              </span>
              <h3 className="font-heading text-xl font-semibold text-foreground-900">{t('about.problem_title')}</h3>
            </div>
            <p className="text-foreground-600 text-sm leading-relaxed">{t('about.problem_text')}</p>
          </div>
          <div className="bg-accent-50 rounded-2xl p-8 md:p-10">
            <div className="flex items-center gap-3 mb-4">
              <span className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center">
                <i className="ri-lightbulb-line text-accent-600 text-lg w-5 h-5 flex items-center justify-center"></i>
              </span>
              <h3 className="font-heading text-xl font-semibold text-foreground-900">{t('about.solution_title')}</h3>
            </div>
            <p className="text-foreground-600 text-sm leading-relaxed">{t('about.solution_text')}</p>
          </div>
        </div>
      </div>
    </section>
  );
}